import { Grid, styled } from "@mui/material";

interface TemperatureContainerProps {
  highlighted: boolean;
}

export const TemperatureContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "highlighted",
})<TemperatureContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #ffd200;
  height: 80px;
  width: 80px;
  background: ${({ highlighted }) => (highlighted ? "#fff" : "#d8d8d8")};
  padding: 10px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  &:hover {
    filter: brightness(0.9);
  }
`;
